module.exports = __webpack_public_path__ + "static/media/doctors-screen.f550c3bb.png";